// 导入biguint-format
import {format} from 'biguint-format';
// 导入uuid
import {v4 as uuidv4} from 'uuid';
import {isEmpty, isNumber, size} from 'lodash';
import {getAssetPath} from '@stencil/core';
import {ShapeConstants, VALUE_PREFIX} from './penpot/constant';
import {transTextContentToFont} from './penpot/transform/font';
import {transTextContentLetterSpacing} from './penpot/transform/letterSpacing';
import {transTextContentTextAlign} from './penpot/transform/textAlign';
import {transTextContentFillsToColor} from './penpot/transform/textContentFills';
import {transTextContentTextDecoration} from './penpot/transform/textDecoration';
import {transTextContentTextTransform} from './penpot/transform/textTransform';
import {transTextContentVerticalAlign} from './penpot/transform/verticalAlign';
import {transRotationToTransform} from './penpot/transform/rotation';
import {transBlurToFilter} from './penpot/transform/blur';
import {transFillsToBackground} from './penpot/transform/fills';
import {transStrokesToOutline} from './penpot/transform/strokes';
import {transShadowToBoxShadow} from './penpot/transform/shadow';
import {transRToBorderRadius} from './penpot/transform/r';
import {transPathContentToD} from './penpot/transform/pathContent';
import {EVENT_CONFIG, EVENT_TYPES} from '../constant/common';
import {transHidden} from './penpot/transform/hidden';
import {EVENT_ENUM, eventFun} from './eventFunUtil';
import {astStore, webDesignerMsg} from '../store';
import {getASTComponentById, getConigAST, updateASTComponents} from '../store/common/action';
import {SnowflakeService} from './snowflake';
import {getRemValue} from './tailwindcss';
import {getValue} from '../store/common/CacheGlobal';
import {parseToCssDefault} from "../layout/calcLayout";
import {getKeyValue, LANGUAGE} from "../store/common/localStorageManager";

const snowflake = new SnowflakeService();

export function flakeId() {
  return snowflake.generate();
}

export function penpotId() {
  return `~u${uuidv4()}`;
}

export const getClientId = (len) => {
  //生成九位随机字符串 用于client_id
  len = len || 9;
  let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789';
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

//提起字符串中数值加数值前面的字符
export const getStrNumAndLetter = (str) => {
  let result = ''
  for (let i = 0; i <= str.length; i++) {
    if (!isNaN(Number(str[i]))) {
      result = str[i - 1] + str[i]
      return result
    }
  }
}

/**
 * 将组件uuid转换成querySelector可以识别的字符串
 * @param id
 */
export const handleDomUUID = (id) => {
  return id.replaceAll(VALUE_PREFIX, '');
};

export const generateCanvasID = () => {
  return 'p' + uuidv4().split('-').join('');
};

export const uuid4 = () => {
  return 'p' + uuidv4().split('-').join('');
};


export const generateUUID = () => {
  return `${VALUE_PREFIX}${uuidv4()}`;
};

export function isDeepStrictEqual(a, b) {
  // 处理基本类型（包括 NaN）
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (typeof a !== 'object' || a === null || b === null) {
    return a !== a && b !== b; // 处理 NaN
  }

  // 处理特殊对象类型（如 Date、RegExp）
  const aConstructor = a.constructor;
  const bConstructor = b.constructor;
  if (aConstructor !== bConstructor) return false;
  if (a instanceof Date) return a.getTime() === b.getTime();
  if (a instanceof RegExp) return a.toString() === b.toString();

  // 处理数组
  if (Array.isArray(a)) {
    if (a.length !== b.length) return false;
    return a.every((item, index) => isDeepStrictEqual(item, b[index]));
  }

  // 处理普通对象
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every(key =>
    Object.prototype.hasOwnProperty.call(b, key) &&
    isDeepStrictEqual(a[key], b[key]),
  );
}


/**
 * 提供调用其他页面的函数
 * @param type
 * @param value
 */
export const getPageConfig = async (type, value) => {
  await customElements.whenDefined(`${type}`);
  const todoListElement = document.querySelector(`${type}`);
  if (todoListElement) {
    await (todoListElement as any).handleSWFun(value);
  }
};

/**
 * 刷新树
 * @param type
 */
export const getRefreshConfig = async (type) => {
  await customElements.whenDefined(`${type}`);
  const todoListElement = document.querySelector(`${type}`);
  if (todoListElement) {
    await (todoListElement as any).handleRefreshTreeFun();
  }
};


export const formatBigInt = (bigIntValue) => {
  return format(bigIntValue, 'hex');
};

// 查找函数
export const findIn2DArray = (arr, predicate) => {
  for (let i = 0; i < arr.length; i++) {
    const found = arr[i].component.find(predicate);
    if (found) return found;
  }
  return null;
};

export const updateStatusObj = (array, newObject, index) => {
  let indexToRemove = index; // 要删除的索引
  // 在删除旧对象之前，确保索引在数组范围内
  if (indexToRemove >= 0 && indexToRemove < array.length) {
    // 删除旧对象
    array.splice(indexToRemove, 1);
    // 在指定索引处添加新对象
    array.splice(indexToRemove, 0, newObject);
  }
  return array;
};


// 使用typeof操作符
export const isObjectNotEmpty = (obj) => {
  return typeof obj !== 'undefined' && obj !== null;
};

export const getIsAssetPath = (path) => {
  getAssetPath(path);
};

/**
 * 落地页统一缓存ast
 * @param dataValue
 * @param key
 * @param value
 * @param componentKey
 */
export const onChangePropDesign = async (dataValue: object, key: string, value: any) => {
  _set(dataValue, key, value);
  // await updateDesignAst(dataValue, componentKey);
};

// 将 dom 内联样式取出转成数字类型（单位：rem）
export const convertInlineCss2Rem = (value: any): number => {
  if (!(`${value}`.trim())) return 0;
  let v = value;
  if (!isNumber(value)) v = parseFloat(value);
  const rem = parseFloat(getRemValue());
  return !isNaN(v) ? (`${value}`.endsWith('px') ? (v / rem) : v) : 0; // px 要转成 rem
};

// 转换成数值
export const convertInlineCss2Number = (value: any): number => {
  if (!(`${value}`.trim())) return 0;
  let v = value;
  if (!isNumber(value)) v = parseFloat(value);
  return !isNaN(v) ? v : 0;
};

/**
 * 计算百分比
 * @param value
 */
export const calculatePercentage = (value) => {
  return convertInlineCss2Number(value) / 100
}

/**
 * 计算字符串的分数数值
 * @param value
 */
export const calculateFraction = (value: any) => {
  const [numerator, denominator] = value.split('/').map(Number);
  return (numerator / denominator);
};

// 判断某个元素是否有滚动条
export const hasScrollbar = (element: Element) => {
  const hasHorizontal = element.scrollWidth > element.clientWidth;
  const hasVertical = element.scrollHeight > element.clientHeight;
  return {hasHorizontal, hasVertical};
};

// 获取滚动条宽高
export const getScrollbarSize = () => {
  // 创建用于测量滚动条宽度的外层元素
  const widthOuter = document.createElement('div');
  widthOuter.style.visibility = 'hidden';
  widthOuter.style.overflow = 'scroll';
  document.body.appendChild(widthOuter);

  // 创建内层元素
  const widthInner = document.createElement('div');
  widthOuter.appendChild(widthInner);

  // 计算滚动条宽度
  const scrollbarWidth = widthOuter.offsetWidth - widthInner.offsetWidth;

  // 移除用于测量滚动条宽度的元素
  document.body.removeChild(widthOuter);

  // 创建用于测量滚动条高度的外层元素
  const heightOuter = document.createElement('div');
  heightOuter.style.visibility = 'hidden';
  heightOuter.style.width = '100px';
  heightOuter.style.overflow = 'scroll';
  document.body.appendChild(heightOuter);

  // 创建内层元素
  const heightInner = document.createElement('div');
  heightInner.style.width = '200px';
  heightOuter.appendChild(heightInner);

  // 计算滚动条高度
  const scrollbarHeight = heightOuter.offsetHeight - heightInner.offsetHeight;

  // 移除用于测量滚动条高度的元素
  document.body.removeChild(heightOuter);
  return {scrollbarWidth, scrollbarHeight};
};

/**
 * 获取组件类型
 * @private
 */
export const getComponentType = (value) => {
  return _get(value, 'comps.subject');
};


/**
 * 文本样式
 * @param css
 */
export const textCompStylesEcho = (css) => {
  return {
    ...transTextContentToFont(css[ShapeConstants.content]),
    ...transTextContentLetterSpacing(css[ShapeConstants.content]),
    ...transTextContentTextAlign(css[ShapeConstants.content]),
    ...transTextContentFillsToColor(css[ShapeConstants.content]),
    ...transTextContentTextDecoration(css[ShapeConstants.content]),
    ...transTextContentTextTransform(css[ShapeConstants.content]),
    ...transTextContentVerticalAlign(css[ShapeConstants.content]),
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transBlurToFilter(css[ShapeConstants.blur]),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};

/**
 * 合并定位样式与设计稿中其他transform样式（旋转样式等）
 * @param positionStyle
 * @param otherStyle
 */
export const mergeStyles = (positionStyle, otherStyle) => {
  if (otherStyle?.transform) {
    //此处顺序必须是定位在先其他在后，否则会与设计稿不一致
    positionStyle.transform = `${positionStyle.transform} ${otherStyle.transform} `;
  }
  return {
    ...otherStyle,
    ...positionStyle,
  };
};

/**
 * 矩形
 * @param css
 */
export const rectCompStylesEcho = (css) => {
  return {
    ...transFillsToBackground(css[ShapeConstants.fills]),
    ...transStrokesToOutline(css[ShapeConstants.strokes]),
    ...transShadowToBoxShadow(css[ShapeConstants.shadow]),
    ...transRToBorderRadius(css),
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transBlurToFilter(css[ShapeConstants.blur]),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};


/**
 * 圆形
 * @param css
 */
export const circleCompStylesEcho = (css) => {
  return {
    ...transFillsToBackground(css[ShapeConstants.fills]),
    ...transStrokesToOutline(css[ShapeConstants.strokes]),
    ...transShadowToBoxShadow(css[ShapeConstants.shadow]),
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transBlurToFilter(css[ShapeConstants.blur]),
    ...transRToBorderRadius(css),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};

/**
 * 画板
 * @param css
 */
export const frameCompStylesEcho = (css) => {
  if (!css) {
    return {};
  }
  return {
    ...transFillsToBackground(css[ShapeConstants.fills]),
    ...transStrokesToOutline(css[ShapeConstants.strokes]),
    ...transShadowToBoxShadow(css[ShapeConstants.shadow]),
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transBlurToFilter(css[ShapeConstants.blur]),
    ...transRToBorderRadius(css),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};

/**
 * 组
 * @param css
 */
export const groupCompStylesEcho = (css) => {
  return {
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};

/**
 * 路径
 * @param css
 */
export const pathCompStylesEcho = (css) => {
  return {
    ...transRotationToTransform(css[ShapeConstants.rotation]),
    ...transPathContentToD(css[ShapeConstants.content]),
    ...transFillsToBackground(css[ShapeConstants.fills]),
    ...transHidden(css[ShapeConstants.hidden]),
  };
};


/**
 * 获取背景图和path 路径
 * @param css
 */
export const getPathBackgroundImage = (css) => {
  let flag = false;
  let href = '';
  let pathContent = transPathContentToD(css[ShapeConstants.content]);
  let backgroundCss = transFillsToBackground(css[ShapeConstants.fills]);
  if (_get(backgroundCss, 'backgroundImage')) {
    const regex = /url\(["']?([^"']+)["']?\)/;
    const match = _get(backgroundCss, 'backgroundImage').match(regex);
    if (match) {
      href = match[1]; // 输出: http://192.168.1.21:30881/assets/by-file-media-id/293094c9-3c14-816f-8005-2a9ac5f5a599
    }
    flag = true;
  }
  return {
    flag, href, pathContent,
  };
};


/**
 * 获取文本内容
 * @param css
 */
export const textValueData = (css) => {
  let children = _get(css, [ShapeConstants.content, ShapeConstants.children, 0, ShapeConstants.children, 0, ShapeConstants.children], []);
  return children.map(child => child[ShapeConstants.text]).filter(text => text !== '\n').join('');
};


/**
 * 兼容PP 初始化没有事件
 * 初始化事件
 */
export const initEvent = async () => {
  const components = astStore.state.components;
  for (const data in components) {
    let typeValue = _cloneDeep(await getValue('compAst')).flatMap(innerArray => innerArray['component'])
      .find(item => item.type === components[data].type); // 匹配后返回对象
    if (isEmpty(components[data].event)) {
      _set(components[data], 'event', typeValue.event);
    } else {
      for (const key in typeValue.event) {
        if (!components[data].event[key]) {
          components[data].event[key] = _cloneDeep(typeValue.event[key]);
        }
      }
    }
    if (isEmpty(components[data].hook)) {
      _set(components[data], 'hook', typeValue.hook);
    } else {
      for (const key in typeValue.hook) {
        if (!components[data].hook[key]) {
          components[data].hook[key] = _cloneDeep(typeValue.hook[key]);
        }
      }
    }
    // 兼容path css
    if (components[data].type === 'path' && components[data].css) {
      _set(components[data], 'attrs.pathCss.value', components[data].css);
      delete components[data].css;
    }
    _set(components[data], 'attrs', {..._cloneDeep(typeValue.attrs), ...components[data]['attrs']});
  }
  updateASTComponents(components);
};


/**
 * 获取dom 上的样式
 * @param element
 */
export const getDomStyles = (element) => {
  // 获取该元素的所有计算样式
  const computedStyle = window.getComputedStyle(element);
  const styles = {};
  for (let i = 0; i < computedStyle.length; i++) {
    const property = computedStyle[i];
    styles[property] = computedStyle.getPropertyValue(property);
  }
  return styles;
};

/**
 * 设置dom 上的样式
 * @param element
 * @param styleProperties
 * @param comp_id
 */
export function setDomStyle(element: HTMLElement, styleProperties: Array<string>, comp_id: string) {
  const componentAst = getASTComponentById(comp_id)
  // 提取组件中动态样式
  const styleCss = parseToCssDefault(componentAst);
  if (element && styleCss) {
    styleProperties.forEach((property) => {
      if (styleCss[property]) {
        element.style[property] = styleCss[property];
      }
    });
  }
}


export const findCanvasChildDom = (prop) => {
  const parentElement = document.querySelector('.canvas');
  // 获取 ID 值，并对其进行转义
  const escapedId = CSS.escape(prop);
  // 使用转义后的 ID 查找子元素
  const dom: HTMLElement = parentElement ? parentElement.querySelector('.canvas #' + escapedId) : null;
  return dom;
};

export function configEventFunction(eventType, eventTrigger, componentId, mid, component, labelTitle: string = `${eventTrigger}`) {
  let configAST = getConigAST();
  let triggerSetting = _get(component, `${eventType}.${eventTrigger}.triggerSetting`);
  let pureFunctionSetting = _get(configAST, 'pureFunction',[]);    // 获取全局函数
  let payload = {eventType, eventTrigger, componentId, triggerSetting,pureFunctionSetting, configAST, component, labelTitle};
  sendMsg({mid, type: 'webDesignerMsg', method: 'configEventFunction', payload});
}

export const sendMsg = ({mid, type, method, payload}: webDesignerMsg) => {
  console.log('sendMsg', {mid, type, method, payload});
  window.top.postMessage(
    {
      mid,
      type,
      method,
      payload,
    },
    window.document.referrer || window.location.href,
  );
};


/**
 * 标记是否配置事件
 * @param data
 * @param event
 * @param eventName
 */
export const badgeEvent = (data, event, eventName) => {
  // 确保访问路径的每一部分都存在
  if (data && data[event] && data[event][eventName] &&
    data[event][eventName].triggerSetting &&
    data[event][eventName].triggerSetting.functionBody) {
    // 判断 functionBody 的长度是否大于 1
    return data[event][eventName].triggerSetting.functionBody.length > 1;
  }
  // 如果路径不存在或数据不完整，返回 false
  return false;
};


/**
 * 更新事件配置
 * @param data
 * @param eventTypes
 */
export const updateEventConfig = (data, eventTypes) => {
  const eventConfig = _cloneDeep(EVENT_CONFIG);
  const {event} = data;
  if (event) {
    eventTypes.forEach(eventType => {
      // 可视化面板
      if (_get(event, [eventType, 'triggerSetting', 'functionBody']) && size(_get(event, [eventType, 'triggerSetting', 'functionBody'])) > 0) {
        eventConfig[eventType] = true;
      }
    });
  }
  return eventConfig;
};


// 根据配置生成事件绑定对象
export const getEventHandlers = (data, eventConfig, instanceId) => {
  return EVENT_TYPES.reduce((handlers, eventType) => {
    if (eventConfig[eventType]) {
      handlers[`on${eventType.charAt(0).toUpperCase() + eventType.slice(1)}`] = (event) =>
        handleEvent(event, data, EVENT_ENUM[eventType], instanceId);
    }
    return handlers;
  }, {});
};


// 统一事件处理函数
export const handleEvent = async (event, data, eventType, instanceId) => {
  console.log('handleEvent==', event, data, eventType, instanceId);
  event.stopPropagation(); // 阻止冒泡
  await eventFun(data, eventType, instanceId);
};


/**
 * 兼容文本
 * @param compStyles
 * @param height
 */
export const textStyle = (compStyles, height?) => {
  // 垂直居中样式行高=组件高度
  if (_get(compStyles, 'verticalAlign') === 'middle') {
    if (height) {
      compStyles['lineHeight'] = `${height}px`;
    } else {
      compStyles['lineHeight'] = _get(compStyles, 'height');
    }
  }
  // 底部对齐使用flex布局实现
  if (_get(compStyles, 'verticalAlign') === 'bottom') {
    compStyles['display'] = 'flex';
    compStyles['alignItems'] = 'flex-end';
  }
  return compStyles;
};


/**
 * 模板组件函数
 * @param list
 * @param oldProp
 * @param newProp
 */
export const replaceEventOrHook = (list, oldProp, newProp) => {
  if (list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      // 将每个对象深拷贝为字符串
      let stringifiedData = JSON.stringify(list[i]);
      // 使用正则批量替换字符串中的值
      list[i] = JSON.parse(stringifiedData.replace(new RegExp(oldProp, 'g'), newProp));
    }
  }
};


export const notify = (message, variant = 'warning', icon = 'info-circle', duration = 3000) => {
  const alert = Object.assign(document.createElement('sl-alert'), {
    variant,
    closable: true,
    duration: duration,
    innerHTML: `
        <sl-icon name="${icon}" slot="icon"></sl-icon>
        ${escapeHtml(message)}
      `,
  });

  document.body.append(alert);
  return alert.toast();
};

export const escapeHtml = (html) => {
  const div = document.createElement('div');
  div.textContent = html;
  div.className = ('sl-toast-stack ');
  return div.innerHTML;
};

/**
 * 合并对象到组件的attrs
 * @param comp
 * @param obj
 */
export const mergeObj2CompAttrs = (comp, obj) => {
  let attrs = comp['attrs'];
  for (const k of Object.keys(attrs)) {
    let value = _get(attrs, `${k}.value`);
    if (_get(attrs, `${k}.type`) == 'destructuring') {
      // 解构场景
      value = _get(obj, _get(attrs, `${k}.destructuringPath`), value);
    } else {
      value = _get(obj, k, value);
    }
    _set(attrs, `${k}.value`, value);
  }
};


export const parseNDJSON = (jsonString) => {
  const fixedJsonString = jsonString.replace(/\n(?=")/g, '\\n');
  return fixedJsonString
    .split('\n')
    .filter(line => line.trim())
    .map(line => JSON.parse(line));
}


export const addToMap = (map, key, value) => {
  // 如果键不存在，则初始化一个空数组
  if (!map.has(key)) {
    map.set(key, []);
  }
  // 向对应键的数组中添加元素
  map.get(key).push(value);
}

declare global {
  interface Date {
    /**
     * 格式化日期为指定字符串
     * @param format 格式化字符串，支持的占位符: YYYY, MM, DD, HH, mm, ss
     * @returns 格式化后的日期字符串
     */
    nowtime(format: string): string;
  }
}

Date.prototype.nowtime = function (fmt) { // id生成器时间
  let o = {
    "y+": this.getFullYear(),
    "M+": this.getMonth() + 1,               //月份
    "d+": this.getDate(),                    //日
    "H+": this.getHours(),                   //小时
    "m+": this.getMinutes(),                 //分
    "s+": this.getSeconds(),                 //秒
    "f+": this.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "")).substr(4 - RegExp.$1.length);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

/**
 * 生成带特定后缀的规则文本
 * @param {Object} params - 生成参数
 * @param {'uuid'|'time'|'random'|'custom'} params.suffix - 后缀类型
 * @param {string} [params.custom=''] - 自定义后缀内容
 * @param {number} [params.timeNum=0] - 时间类型的随机数位数
 * @param {string} [params.format='YYYYMMDDHHmmss'] - 时间格式化字符串
 * @returns {string} 生成的规则文本
 */
export const generateRules = (params: {
  suffix: 'uuid' | 'time' | 'random' | 'custom';
  custom?: string;
  timeNum?: number;
  format?: string;
}): string => {
  // 解构参数并设置默认值，避免undefined
  const {
    suffix,
    custom = '',
    timeNum = 0,
    format = 'yyyyMMddHHmmss'
  } = params || {};

  // 生成指定位数的补零随机数
  const getPaddedNonce = (length) => {
    if (length <= 0) return '';
    const max = 10 ** length - 1; // 计算最大值（如3位对应999）
    const nonce = Math.floor(Math.random() * (max + 1));
    return String(nonce).padStart(length, '0');
  };

  // 根据后缀类型处理
  switch (suffix) {
    case 'uuid':
      return `${uuid4()}`;

    case 'time':
      const timeStr = new Date().nowtime(format);
      const nonce = getPaddedNonce(Number(timeNum));
      return `${timeStr}${nonce}`;

    case 'random':
      return `${flakeId()}`;

    case 'custom':
      return `${custom}`;

    default:
      throw new Error(`不支持的后缀类型: ${suffix}`);
  }
};


export const ruleGeneration = (attrs) => {
  const suffix = _get(attrs, ['rulesType', 'value']);
  const timeNum = _get(attrs, ['timeNum', 'value']);
  const format = _get(attrs, ['format', 'value']);
  // 如果是绑定回显，不应该在重新生成ID
  let old_textValue = _get(attrs, ['textValue', 'value'])
  if (!old_textValue) {
    const params = {suffix, timeNum, format}
    return generateRules(params);
  }
}

/**
 * 校验返回
 * @param data
 */
export const verify = (data) => {
  if (_get(data, ['attrs', 'textValue', 'rules', 0, 'pattern'])) {
    const pattern = data.attrs['textValue'].rules[0].pattern; // 正则表达式校验规则
    console.log("校验值---", _get(data.attrs, ['textValue', 'value']))
    try {
      // 字符串转正则（注意：需处理转义符，如手机号规则 "^1[3-9]\\d{9}$"）
      const reg = new RegExp(pattern);
      if (!reg.test(_get(data.attrs, ['textValue', 'value'])) || _size(_get(data.attrs, ['textValue', 'value'])) == 0) {
        return _get(data.attrs, ['textValue', 'rules', 0, 'message'], '');
      }
    } catch (e) {
      console.log('error while collectFormData', e);
    }
  }
  return ""
}


/**
 * 注入类样式：支持原生CSS嵌套+复杂选择器（伪类/组合选择器/&父引用）
 * @param scopeId 样式作用域ID（如 plugin-p6bf05a7da6a14112baf3602158c26019）
 * @param classStyles 类样式配置 { 类名: { 样式属性: 值, 嵌套选择器: 样式配置 } }
 * 支持场景：伪类/伪元素/组合选择器/&父引用/多层嵌套/驼峰属性自动转中划线
 */
export function injectClassStyles(scopeId, classStyles) {
  // 基础入参校验
  if (!scopeId || !classStyles || Object.keys(classStyles).length === 0) return;

  const newStyles = {};
  for (const [key, value] of Object.entries(classStyles)) {
    // 这里对 key 做处理，非数字和非字母的才要解码，MongoDB 的 key 不能有 "." 和 "$" 敏感字符串
    const newKey = key.replace(/&#(\d+);/g, (_, code) => {
      const charCode = parseInt(code, 10);
      return String.fromCharCode(charCode);
    });
    newStyles[newKey] = value;
  }
  classStyles = newStyles;


  // 移除旧样式标签（避免重复）
  const oldStyleTag = document.getElementById(`${scopeId}-styles`);
  if (oldStyleTag) oldStyleTag.remove();

  // 生成CSS文本（根选择器为#scopeId）
  let cssText = `/* ${scopeId} 专属样式 */\n`;
  const rootSelector = `#${scopeId}`;

  /**
   * 递归处理嵌套样式
   * @param {Object} styles 当前层级的样式配置
   * @param {number} level 嵌套层级（控制缩进）
   * @param {string} parentSelector 当前层级的父选择器（用于&替换）
   * @returns {string} 当前层级生成的CSS文本
   */
  const processStyles = (styles, level = 0, parentSelector = '') => {
    // 仅保留需要的缩进变量：样式属性/嵌套选择器的缩进（层级+1）
    const propIndent = '  '.repeat(level + 1);
    let currentCss = '';

    // 分离：样式属性（如 color: red） 和 嵌套选择器（如 &:hover、.inner）
    const styleProps = {};
    const nestedSelectors = {};

    Object.entries(styles).forEach(([key, value]) => {
      // 值为非数组对象 → 嵌套选择器；否则 → 样式属性（过滤空值）
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        nestedSelectors[key] = value;
      } else if (value !== '' && value != null) {
        styleProps[key] = value;
      }
    });

    // 1. 生成当前层级的样式属性（驼峰转中划线）
    const styleRules = Object.entries(styleProps)
      .map(([prop, value]) => {
        const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
        return `${propIndent}${cssProp}: ${value};`;
      })
      .join('\n');

    if (styleRules) {
      currentCss += `${styleRules}\n`;
    }

    // 2. 处理嵌套选择器（伪类/组合选择器/&引用/普通类）
    Object.entries(nestedSelectors).forEach(([selector, nestedStyles]) => {
      let actualSelector = selector;
      // 处理&符号（父选择器引用）
      if (selector.includes('&')) {
        actualSelector = selector.replace(/&/g, parentSelector);
      }
      // 普通类名（无特殊前缀）→ 自动补全.（如 table-div → .table-div）
      else if (
        !selector.startsWith('.') &&
        !selector.startsWith(':') &&
        !selector.startsWith('>') &&
        !selector.startsWith('+') &&
        !selector.startsWith('~') &&
        !selector.startsWith('#') &&
        !selector.startsWith('::')
      ) {
        actualSelector = `.${selector}`;
      }

      // 拼接嵌套选择器的CSS块
      currentCss += `${propIndent}${actualSelector} {\n`;
      // 递归处理子层级（层级+1，父选择器更新为当前actualSelector）
      currentCss += processStyles(nestedStyles, level + 1, actualSelector);
      currentCss += `${propIndent}}\n`;
    });

    return currentCss;
  };

  // 构建根选择器的嵌套CSS
  cssText += `${rootSelector} {\n`;
  Object.entries(classStyles).forEach(([className, styles]) => {
    // 根层级类名自动补全.（如 table-header → .table-header）
    const classSelector = className.startsWith('.') ? className : `.${className}`;
    cssText += `  ${classSelector} {\n`;
    // 递归处理子样式（初始层级2，父选择器为当前类选择器）
    cssText += processStyles(styles, 2, classSelector);
    cssText += `  }\n`;
  });
  cssText += `}\n`;

  // 调试日志（可根据需要删除）
  // console.log(`[injectClassStyles] ${scopeId} 生成的CSS：\n`, cssText);

  // 注入样式到<head>标签
  const styleTag = document.createElement('style');
  styleTag.id = `${scopeId}-styles`;
  styleTag.textContent = cssText;
  const head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(styleTag);
}

/**
 * 注入内联样式：ID查找失败时直接用scopeId作为Class查找，且兼容纯类名/ID选择器输入 + 嵌套选择器
 * @param scopeId 样式作用域ID/Class（如 plugin-pcc03f63a11974d619116ff18349ee424）
 * @param inlineStyles 内联样式配置 { 选择器/类名/ID: { 样式属性: 值 | 嵌套选择器 } }
 */
export function injectInlineStyles(scopeId, inlineStyles) {
  // 入参校验
  if (!scopeId || !inlineStyles || typeof inlineStyles !== 'object' || Array.isArray(inlineStyles) || Object.keys(inlineStyles).length === 0) {
    console.warn('injectInlineStyles: 无效入参，scopeId或inlineStyles不合法');
    return;
  }

  const newStyles = {};
  for (const [key, value] of Object.entries(inlineStyles)) {
    // 这里对 key 做处理，非数字和非字母的才要解码，MongoDB 的 key 不能有 "." 和 "$" 敏感字符串
    const newKey = key.replace(/&#(\d+);/g, (_, code) => {
      const charCode = parseInt(code, 10);
      return String.fromCharCode(charCode);
    });
    newStyles[newKey] = value;
  }
  inlineStyles = newStyles;

  // 优先通过ID查找作用域根节点，失败则用scopeId作为Class查找
  let scopeRoot = document.getElementById(scopeId);
  if (!scopeRoot) {
    console.warn(`injectInlineStyles: ID ${scopeId} 未找到，尝试用Class .${scopeId} 查找`);
    scopeRoot = document.querySelector(`.${scopeId}`);
  }
  if (!scopeRoot) {
    console.error(`injectInlineStyles: 作用域根节点查找失败：ID=${scopeId} / Class=.${scopeId} 均未找到`);
    return;
  }

  // 缓存正则表达式（避免重复创建）
  const REGEX = {
    // 匹配合法的CSS属性名（支持驼峰/中划线）
    cssProp: /^[a-zA-Z0-9]+(?:[A-Z-][a-zA-Z0-9]+)*$/,
    // 判断是否为嵌套选择器标识（. # : & > + ~ 开头，或包含空格）
    nestedSelector: /^(\.|#|:|&|>|\+|~)|\s+/,
    // 纯类名/ID名（无特殊符号）
    pureClassName: /^[a-zA-Z0-9-]+$/
  };

  /**
   * 递归扁平化嵌套样式
   * @param styles 样式配置
   * @param parentSelector 父选择器
   * @param depth 递归深度
   */
  const flattenStyles = (styles, parentSelector = '', depth = 0) => {
    // 递归深度限制（防止死循环）
    if (depth > 10) {
      console.warn(`injectInlineStyles: 递归深度超过10层，终止解析：parentSelector=${parentSelector}`);
      return {};
    }

    // 非对象直接返回空
    if (!styles || typeof styles !== 'object' || Array.isArray(styles)) {
      return {};
    }

    const result = {};
    const currentStyle = {}; // 当前层级样式属性
    const nestedSelectors = {}; // 当前层级嵌套选择器

    // 分离样式属性和嵌套选择器
    Object.entries(styles).forEach(([key, value]) => {
      // 空值跳过
      if (value === null || value === undefined) return;

      // value是对象 → 判定为嵌套选择器
      if (typeof value === 'object' && !Array.isArray(value)) {
        nestedSelectors[key] = value;
        return;
      }

      // value非对象 → 判定为样式属性（需校验属性名合法性）
      if (REGEX.cssProp.test(key)) {
        currentStyle[key] = String(value).trim();
      } else {
        console.warn(`injectInlineStyles: 无效CSS属性名，跳过：${key}=${value}`);
      }
    });

    // 处理当前层级样式
    if (parentSelector && Object.keys(currentStyle).length > 0) {
      result[parentSelector] = {
        ...(result[parentSelector] || {}),
        ...currentStyle
      };
    }

    // 递归处理嵌套选择器
    Object.entries(nestedSelectors).forEach(([selector, nestedStyles]) => {
      // 拼接完整选择器（支持&引用父选择器）
      let fullSelector;
      if (selector.includes('&')) {
        fullSelector = selector.replace(/&/g, parentSelector || '');
      } else if (parentSelector) {
        // 处理组合选择器（> + ~）和后代选择器
        fullSelector = REGEX.nestedSelector.test(selector)
          ? `${parentSelector}${selector}`
          : `${parentSelector} ${selector}`;
      } else {
        fullSelector = selector;
      }

      // 递归扁平化子样式并合并结果
      const childResult = flattenStyles(nestedStyles, fullSelector, depth + 1);
      Object.keys(childResult).forEach(key => {
        result[key] = {
          ...(result[key] || {}),
          ...childResult[key]
        };
      });
    });

    return result;
  };

  // 扁平化嵌套样式
  const processedStyles = flattenStyles(inlineStyles);
  console.debug(`injectInlineStyles: 扁平化后样式配置`, processedStyles);
  console.log(`injectInlineStyles: 扁平化后样式配置`, processedStyles);

  // 注入内联样式到目标元素
  Object.entries(processedStyles).forEach(([selector, styles]) => {
    if (!selector || Object.keys(styles).length === 0) return;

    // 查找目标元素（作用域内查找）
    let targetElements = scopeRoot.querySelectorAll(selector);

    // 未找到时，尝试补全类名前缀（纯类名情况）
    // if (!targetElements.length && REGEX.pureClassName.test(selector)) {
    if (!targetElements.length && !`${selector}`.startsWith('.')) {
      const fallbackSelector = `.${selector}`;
      console.debug(`injectInlineStyles: 选择器${selector}未找到，尝试补全类名：${fallbackSelector}`);
      console.log(`injectInlineStyles: 选择器${selector}未找到，尝试补全类名：${fallbackSelector}`);
      targetElements = scopeRoot.querySelectorAll(fallbackSelector);
    }

    if (!targetElements.length) {
      console.warn(`injectInlineStyles: 作用域${scopeId}内未找到元素：${selector}`);
      console.log(`injectInlineStyles: 作用域${scopeId}内未找到元素：${selector}`);
      return;
    }

    //  修改样式（跟左哥沟通，当前的id节点dom也含有class，则也需要插入pluginCss样式）
    if (scopeRoot.classList.contains(selector.replace(/^\./, ''))) { // 如果第一个字符是".", 就去掉"."再匹配
      Object.entries(styles).forEach(([prop, value]) => {
        // 驼峰转中划线（如 backgroundColor → background-color）
        const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();

        if (value === '') {
          // 空值移除样式属性
          scopeRoot.style.removeProperty(cssProp);
        } else {
          // 设置样式（优先用setProperty保证兼容性）
          scopeRoot.style.setProperty(cssProp, value);
        }
        console.debug(`injectInlineStyles: [${scopeId}] ${cssProp}: ${value} (元素: ${scopeRoot.tagName}.${scopeRoot.className})`);
      });
    }

    // 为每个子孙元素设置内联样式
    targetElements.forEach(el => {
      if (!(el instanceof HTMLElement)) return;

      Object.entries(styles).forEach(([prop, value]) => {
        // 驼峰转中划线（如 backgroundColor → background-color）
        const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();

        if (value === '') {
          // 空值移除样式属性
          el.style.removeProperty(cssProp);
        } else {
          // 设置样式（优先用setProperty保证兼容性）
          el.style.setProperty(cssProp, value);
        }
        console.debug(`injectInlineStyles: [${scopeId}] ${cssProp}: ${value} (元素: ${el.tagName}.${el.className})`);
      });
    });
  });

  console.log(`injectInlineStyles: 样式注入完成，作用域：${scopeId}`);
}

/**
 * 清理指定作用域的样式标签（组件销毁时调用）
 * @param scopeId 样式作用域ID
 */
export function clearScopeStyles(scopeId: string): void {
  const styleTag = document.getElementById(`${scopeId}-styles`);
  if (styleTag) styleTag.remove();
}

export function getLanguage() {
  let currentLang = getKeyValue(LANGUAGE);
  if (!currentLang) {
    currentLang = navigator.language
  }
  console.log("最终浏览器语言：", currentLang);
  return currentLang;
}
